import $ from 'jquery';

export default () => {
  const locales = $(`.locales`);
  const list = locales.find(`.locales__list`);
  const items = locales.find(`.locales__item`);
  const unfoldedHeight = list.outerHeight() + locales.outerHeight() + 5;
  const ACTIVE_LOCALE_CLASSNAME = 'locales--active-change';
  const toggle = () => {
    const isLocaleOpened = locales.hasClass(ACTIVE_LOCALE_CLASSNAME);

    locales.toggleClass(ACTIVE_LOCALE_CLASSNAME);
  };
  const remove = () => {
    locales.removeClass(ACTIVE_LOCALE_CLASSNAME);
  };
  const handler = (evt) => {
    if (evt.target.tagName === `A`) return;

    evt.target.closest(`.locales`) ? toggle() : remove()
  };

  items.each((index, locale) => {
    const initialText = $(locale).html();

    $(locale).html(initialText[0] + initialText[1].toLowerCase());
  });

  $(document).click(handler);
}
